/** gap-2 = 0.5rem = 8px. */
export const SUBCATEGORY_TAG_GAP_PX = 8;

/** Tag height (h-10) × 2 rows + one gap-2 between rows. */
export const SUBCATEGORY_TAG_TWO_ROW_HEIGHT_CLASS = 'h-[5.6rem]';

/**
 * Simulates flex-wrap row-filling by summing child widths against the
 * available container width. Returns how many rows would be needed.
 */
export function countFlexWrapRowsFromWidths(
    containerWidth: number,
    childWidths: number[],
    gap = SUBCATEGORY_TAG_GAP_PX
): number {
    if (childWidths.length === 0 || containerWidth <= 0) {
        return 0;
    }

    let rows = 1;
    let currentRowWidth = 0;

    for (const childWidth of childWidths) {
        if (currentRowWidth > 0 && currentRowWidth + gap + childWidth > containerWidth) {
            rows++;
            currentRowWidth = childWidth;
        } else {
            currentRowWidth += (currentRowWidth > 0 ? gap : 0) + childWidth;
        }
    }

    return rows;
}

export function countFlexWrapRows(container: HTMLElement): number {
    const childWidths = measureSubcategoryTagWidths(container);

    return countFlexWrapRowsFromWidths(container.clientWidth, childWidths);
}

/** Reads intrinsic tag widths from `[data-tag-item]` nodes (skips `display: contents` wrappers). */
export function measureSubcategoryTagWidths(container: HTMLElement): number[] {
    const tagNodes = container.querySelectorAll<HTMLElement>('[data-tag-item="true"]');

    return Array.from(tagNodes).map((node) => {
        const nodeWidth = node.getBoundingClientRect().width;
        return nodeWidth > 0 ? nodeWidth : 0;
    });
}
